export const services = [
  {
    image: "content/services/audit.png",
    heading: "Website Optimisation",
    description:
      "Looking to improve your page performance, SEO, or user experience? Request a free site audit. ",
  },
  {
    image: "content/services/coding.png",
    heading: "Website development",
    description:
      "Develop websites - optimized for performance, search engines, and converting users to customers. ",
  },
  {
    image: "content/services/conversation.png",
    heading: "Consulting",
    description:
      " Consult with clients to determine the scope of website development projects, implement SEO strategies to increase traffic flow to websites, and maintain websites.",
  },
  {
    image: "content/services/smartphone.png",
    heading: "Responsive",
    description:
      "A responsive design makes your website accessible to all users, regardless of their device.",
  },
];
export const jobsData = [
  {
    title: "Senior Engineer",
    company: "Robert Bosch",
    location: "Bangalore, KA",
    range: "January - April 2018",
    url: "https://www.bosch-softwaretechnologies.com/en/",
    description:
      "<ul>\n<li>Developed product inventory where user can subscribe to various plans for respective services.</li>\n<li>Developed user interface with ReactJS (Hooks), Typescript and Antd to meet requirements.</li>\n<li>Implemented global state management using Redux and internationalization with react-i18next.</li>\n<li>Familiar with Continuous Integration/Delivery pipeline for cloud using Jenkins, SonarQube, Docker.</li>\n</ul>",
  },
  {
    title: "Software Engineer",
    company: "Webenza India Pvt Ltd",
    location: "Bangalore, KA",
    range: "July - December 2017",
    url: "https://www.webenza.com/",
    description:
      "<ul>\n<li>Developed a parking solution admin dashboard with ReactJS components and Material UI.</li>\n<li>Integrate data from API's to create dashboard widgets like charts, Google maps using axios.</li>\n<li>Troubleshoot interface software and debugged application code to improve functionality and performance.s</li>\n</ul>",
  },
  {
    title: "Software Developer",
    company: "IBM India Pvt Ltd.",
    location: "Hyderabad, TS",
    range: "January - April 2018",
    url: "https://www.ibm.com/in-en",
    description:
      "<ul>\n<li>Migration project which involved building reusable components and features using ReactJS Components, Forms, Events, Keys, Router.</li>\n<li>Improved load time of the webpage by memoizing with hooks and lazy loading.</li>\n</ul>",
  },
  {
    title: "UI Developer",
    company: "CREATE@Amrita",
    location: "Kollam, KE",
    range: "July - December 2017",
    url: "http://www.amritacreate.org/",
    description:
      "<ul>\n<li>Transforming learning analytics platform from fluid design to responsive theme with Twitter Bootstrap which improved website traffic.</li>\n<li>Cross Browser compatibility testing was performed.</li>\n<li>Developing experiment simulations with native javascript.</li>\n<li>Integrate various jQuery plugins into the development cycle.</li>\n</ul>",
  },
];
export const works = [
  {
    title: "Ant Design Dashboard",
    tech: ["VS Code", "Ant Design", "React", "Javascript", ""],
    github: "https://github.com/praveesh91/SITE_demo/tree/master",
    external: "https://master.d21h3qsh5st3dt.amplifyapp.com/dashboard",
    cta: null,
    image: "content/featured/HalcyonTheme/demo.png",
    description:
      '<p>A minimal, <a href="https://marketplace.visualstudio.com/items?itemName=brittanychiang.halcyon-vscode" target="_blank" rel="nofollow noopener noreferrer">ant design</a> dahboard theme integrated with various widgets like graphs, timeline etc. Data can be integrated with third party JSON or local data.</a>',
  },
  {
    title: "Bankist Webiste",
    tech: ["VS Code", "Javascript"],
    github: "https://github.com/praveesh91/Banking-template",
    external: "https://festive-hypatia-120fbb.netlify.app/",
    cta: null,
    image: "content/featured/SpotifyProfile/demo.png",
    description:
      "<p>A modern, responsive website buils purely on native javascript. The website enables the client to showcase their features.",
  },
  {
    title: "Parking Management Dashboard",
    tech: ["VS Code", "Javascript", "React.Js", "Material UI"],
    github:
      "https://github.com/praveesh91/React_MareialUI_Dashboard/tree/master",
    external: "https://master.d33iiktbeebmnt.amplifyapp.com/",
    cta: null,
    image: "content/featured/SpotifyProfileV2/demo.png",
    description:
      "<p>Parking Solution admin which keeps track of the parking data of a parking provider using various visualisation widgets. The location data is integrated with google maps. Fetching live updated data from the APIs.</p>",
  },
];
export const projectList = [
  {
    frontmatter: {
      title: "Online Labs",
      tech: ["Javascript", "Bootstrap", "JQuery"],
      external: "http://www.olabs.edu.in/",
    },
    html: "<p>Online Labs is a web based experiment simulation interface build purely in native javascript.</p>",
  },
  {
    frontmatter: {
      title: "Product Portal",
      tech: ["React.js", "Ant Design", "Javascript"],
      github: "",
    },
    html: "<p>Web interface build for the client to manage and create various regulations. This is build with React and AntD, involves integrating backend API built with Java.</p>",
  },
  {
    frontmatter: {
      title: "Corporate Website",
      tech: ["React.js", "Bootstrap", "AWS Amplify"],
      github: "https://github.com/praveesh91/Task_Website/tree/master",
      external: "https://master.d39vzl9oqgwjit.amplifyapp.com/",
    },
    html: "<p>A single page, responsive web interface for corporate, built with Javascript, Bootstrap and hosted in AWS Amplify</p>",
  },
  {
    frontmatter: {
      title: "E-Waste Management",
      tech: ["React.js", "Bootstrap", "AWS Amplify"],
      github: "https://github.com/praveesh91/wasteManagementSite",
      external: "https://main.d31ttz1ari6y6f.amplifyapp.com/",
    },
    html: "<p>A single page, responsiive web interface build purely in HTML5, CSS3, and Bootstrap components and hosted in AWS Amplify.</p>",
  },
  {
    frontmatter: {
      title: "Quiz Application",
      tech: ["React.js", "Material UI", "AWS Amplify"],
      github: "https://github.com/praveesh91/weinvestQuiz",
      external: "https://master.d3ezzvdpu3szgl.amplifyapp.com/",
    },
    html: "<p>This is one of the task website which I created during my hiring process build with Material UI and ReactJs</p>",
  },
  {
    frontmatter: {
      title: "Product Store",
      tech: ["React.js", "Ant Design", "Javascript"],
      github: "",
    },
    html: "<p>A product inventory for the client to showcase their wide range of products to the users . Tech stack involves ReactJs, Ant design and integration of backend API's</p>",
  },
];
const intro = {};
